// extracted by mini-css-extract-plugin
export default {"desktopDescription":"nwhWOp","mobileDescription":"ovtjFg"};